
import '../../Styles/index.css';

import { useCallback, useState, useEffect } from 'react';
import {
    TERipple,
    TEModal,
    TEModalDialog,
    TEModalContent,
    TEModalHeader,
    TEModalBody,
    TEModalFooter,
} from "tw-elements-react";

import izenuAPI from '../../services/izenuAPI';

export default function Lyrics() {
    const [strSearch, setStrSearch] = useState("");
    const [results, setResults] = useState([]);
    const [response, setResponse] = useState("");
    const [lyric, setLyric] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [music, setMusic] = useState({});

    const submit = useCallback(async (e) => {
        e.preventDefault();
        if (!strSearch.trim()) return;
        const { data: r } = await izenuAPI.get(`/admin/lyric/find.php?title=${encodeURIComponent(strSearch)}`);
        if (r.response) {
            setResults(r.musics);
            setResponse("");
        } else {
            setResults([]);
            setResponse("Não há ocorrências para " + strSearch);
        }
    }, [strSearch]);

    const insert = useCallback(async () => {

        let m = music;
        m.admin_id = localStorage.getItem('id');
        m.lyric = lyric;
        setShowModal(false);
        setLyric("");
        const { data: r } = await izenuAPI.post(`/admin/lyric/insert.php`, m);
        if (r.response) {
            alert("Letra adicionada com sucesso!");
        } else {
            alert("Impossivel adicionar letra da musica");
        }

    }, [music, lyric]);
    return (<div className="max-w-3xl mx-auto text-left">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">Adicionar letras às músicas</h1>

        <form onSubmit={submit} className="flex items-center gap-2 p-1.5 ps-4 rounded-full border border-slate-300 bg-white">
            <input value={strSearch} onChange={(e) => setStrSearch(e.target.value)} className="min-w-0 flex-1 bg-transparent border-0 focus:ring-0 text-sm p-1.5" type="search" placeholder="Pesquisar música..." />
            <button type="submit" className="shrink-0 bg-black text-xs font-medium !text-slate-50 uppercase rounded-full px-4 py-2">
                Pesquisar
            </button>
        </form>

        <div className="pt-6">
            {results.length > 0 && <h3 className="text-sm text-slate-600 mb-3">{results.length} resultados</h3>}
            {response !== "" && <p className="text-sm text-slate-600">{response}</p>}

            <div className="space-y-2">
                {results.map((e) => (
                    <div key={e.music_id} className="w-full p-2 rounded-lg border bg-white flex items-center gap-3">
                        <div className="w-14 h-14 sm:w-16 sm:h-16 shrink-0 rounded-md overflow-hidden bg-gray-200">
                            {e.cover_url?.original_photo_url && <img className="w-full h-full object-cover" src={e.cover_url.original_photo_url} alt="" loading="lazy" />}
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="font-semibold text-gray-900 truncate">{e.title}</p>
                            <p className="text-sm text-gray-600 truncate">{e.singer}</p>
                        </div>
                        <button type="button" className="shrink-0 text-sm font-medium px-3 py-2 rounded-lg bg-amber-500 hover:bg-amber-600 !text-white" onClick={() => {
                            setMusic({ music_id: e.music_id, title: e.title, singer: e.singer });
                            setShowModal(true);
                        }}>
                            Adicionar
                        </button>
                    </div>
                ))}
            </div>
        </div>

        {/* <!-- Modal --> */}
        <TEModal show={showModal} setShow={setShowModal}>
            <TEModalDialog size="lg">
                <TEModalContent className="bg-white-50 w-full">
                    <TEModalHeader style={{ background: "#fff" }}>
                        <h5 className="text-lg sm:text-xl text-black font-medium leading-normal min-w-0 truncate pe-3">
                            Letra para {music.title}
                        </h5>
                        <button
                            type="button"
                            className="box-content rounded-none border-none hover:no-underline hover:opacity-75 focus:opacity-100 focus:shadow-none focus:outline-none"
                            onClick={() => setShowModal(false)}
                            aria-label="Fechar"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="h-6 w-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </TEModalHeader>
                    <TEModalBody style={{ background: "#fff" }}>
                        <textarea value={lyric} onChange={(e) => setLyric(e.target.value)} rows={14}
                            placeholder="Cola aqui a letra..."
                            className="border border-gray-300 rounded-lg w-full p-3 text-sm text-gray-900 focus:ring-amber-500 focus:border-amber-500" />
                    </TEModalBody>
                    <TEModalFooter style={{ background: "#fff" }}>
                        <TERipple rippleColor="light">
                            <button
                                type="button"
                                className="border border-gray-300 bg-gray-100 rounded-lg px-5 py-2 text-xs font-medium uppercase text-gray-700"
                                onClick={() => setShowModal(false)}
                            >
                                Fechar
                            </button>
                        </TERipple>
                        <TERipple rippleColor="light">
                            <button
                                type="button"
                                className="ml-2 !text-slate-50 rounded-lg bg-indigo-500 px-5 py-2 text-xs font-medium uppercase"
                                onClick={() => insert()}
                            >
                                Salvar letra
                            </button>
                        </TERipple>
                    </TEModalFooter>
                </TEModalContent>
            </TEModalDialog>
        </TEModal>
    </div>)
}
